import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ResultOption } from './result-option.component';

import { AutocompletePrediction } from '@/types/google-maps.types';
import { Typography } from '@/components/ui/typography/typography.component';

export type LocationSearchResultsProps = {
  searchResults: AutocompletePrediction[];
  handleLocationClick: (item: AutocompletePrediction) => Promise<void>;
};

export const LocationSearchResults = ({
  searchResults,
  handleLocationClick,
}: LocationSearchResultsProps) => {
  return (
    <div
      className="flex flex-col gap-4"
      data-testid={DataTestIdEnum.LOCATION_RESULT_SEARCH}
    >
      <Typography className="font-semibold">
        Resultados encontrados
      </Typography>

      <div className="flex flex-col gap-5">
        {searchResults.map((result) => (
          <ResultOption
            key={`key-result${result?.placeId ?? ''}`}
            description={result.description}
            callback={async () => {
              await handleLocationClick(result);
            }}
          />
        ))}
      </div>
    </div>
  );
};
